import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Badge} from "antd";
import restService from "../../../services/restService";
import {useToasts} from "react-toast-notifications";
import Modal from "../../../components/common/Modal";
import Pusher from "pusher-js";
import Search from "../../../components/common/Search";
import PaginationComponent from "../../../components/common/Pagination";
import AddNewAgent from "../../../components/common/AddNewAgent";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Agents = () => {
  const {addToast} = useToasts();
  const [agentList, setAgentList] = useState([]);
  const [pageTo, setPageTo] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [from, setFrom] = useState(0);
  const [topUpEValue, setTopUpEValue] = useState(undefined);
  const [topUpEValueAmount, setTopUpEValueAmount] = useState(0);
  const [reduceProfile, setReduceProfile] = useState(undefined);
  const [reduceProfileAmount, setReduceProfileAmount] = useState(0);
  const [pusherChannel, setPusherChannel] = useState(null);
  const [pusherChannel2, setPusherChannel2] = useState(null);
  const [showAddNewAgent, setShowAddNewAgent] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchAgents = (page) => {
    setLoading(true);
    restService.AgentApi.getAgents(page).then(({data}) => {
      setAgentList(data?.data?.data);
      setPageTo(data?.data?.to);
      setTotalEntries(data?.data?.total);
      setFrom(data?.data?.from);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchAgents();
    const pusher = new Pusher(
        import.meta.env.VITE_API_ENVIRONMENT === "dev"
            ? import.meta.env.VITE_PUSHER_KEY_DEVELOPMENT:
            import.meta.env.VITE_API_ENVIRONMENT === "staging" ?
                import.meta.env.VITE_PUSHER_KEY_STAGING
                : import.meta.env.VITE_PUSHER_KEY_PRODUCTION,
      {
        cluster: "eu",
        forceTLS: true,
      }
    );
    const channel = pusher.subscribe(`general-evalue-topup`);
    setPusherChannel(channel);

    const channel2 = pusher.subscribe(`general-debt-reduction`);
    setPusherChannel2(channel2);
  }, []);

  useEffect(() => {
    if (
      pusherChannel &&
      pusherChannel.bind &&
      pusherChannel2 &&
      pusherChannel2.bind
    ) {
      pusherChannel.unbind("agent-evalue-topup");
      pusherChannel2.unbind("agent-debt-reduction");
      pusherChannel.bind("agent-evalue-topup", setTopUpCallback);
      pusherChannel2.bind("agent-debt-reduction", setDebtCallback);
    }
  }, [pusherChannel, pusherChannel2, agentList]);

  const setTopUpCallback = (data) => {
    let indexOf = -1;
    agentList.forEach((a, index) => {
      if (a.id === data.message?.model.id) {
        indexOf = index;
      }
    });

    if (indexOf >= 0) {
      let agent = agentList[indexOf];
      agent.actual_balance = data.message.model.actual_balance;
      agent.balance_available = data.message.model.balance_available;
      agentList[indexOf] = agent;
      setAgentList(agentList);
    }
  };

  const setDebtCallback = (data) => {
    let indexOf = -1;
    agentList.forEach((a, index) => {
      if (a.id === data.message?.model.id) {
        indexOf = index;
      }
    });

    if (indexOf >= 0) {
      let agent = agentList[indexOf];
      agent.balance_owed = data.message.model.balance_owed;
      agentList[indexOf] = agent;
      setAgentList(agentList);
    }
  };
  const topUp = () => {
    let data = {amount: topUpEValueAmount};
    restService.EValueAPi.topUpAgent(data, topUpEValue.id)
      .then((response) => {
        addToast("Successfully Topped up Agent e-value", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setTopUpEValueAmount(0);
        setTopUpEValue(undefined);
      });
  };

  const reduceDebt = () => {
    let data = {amount: reduceProfileAmount};
    restService.EValueAPi.reduceAgentDebt(data, reduceProfile.id)
      .then((response) => {
        addToast("Successfully reduced Agent debt profile", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setReduceProfileAmount(0);
        setReduceProfile(undefined);
      });
  };

  const pageChange = (page) => {
    setCurrentPage(page);
    fetchAgents(page);
  };
  const searchAgentByInput = async (input) => {
    const response = await restService.AgentApi.getAgentBySearchTerm(input);
    const agents = await response?.data?.data?.data;
    setAgentList(agents);
  };

    return (
        <>
          <div className="mt-[5rem] modal-active">
            <div className="intro-y flex w-full justify-between flex-wrap md:flex-row-reverse sm:flex-nowrap items-center mt-2 mb-8">
              <button
                  onClick={() => setShowAddNewAgent(true)}
                  className="btn btn-primary-2 gap-1 items-center shadow-md mr-2"
              >
            <span>
              <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.98389 1.24805C6.24188 1.24805 6.45103 1.45719 6.45103 1.71519V5.45229H10.1881C10.4461 5.45229 10.6553 5.66144 10.6553 5.91943C10.6553 6.17743 10.4461 6.38657 10.1881 6.38657H6.45103V10.1237C6.45103 10.3817 6.24188 10.5908 5.98389 10.5908C5.72589 10.5908 5.51675 10.3817 5.51675 10.1237V6.38657H1.77964C1.52165 6.38657 1.3125 6.17743 1.3125 5.91943C1.3125 5.66144 1.52165 5.45229 1.77964 5.45229H5.51675V1.71519C5.51675 1.45719 5.72589 1.24805 5.98389 1.24805Z"
                    fill="black"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
              </svg>
            </span>
                <span>Add Agent</span>
              </button>

              <div className="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
                <div className="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
                  <Search
                      placeholder={"Search Agent"}
                      onChange={(e) => searchAgentByInput(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading ? (
              // Loading skeleton
              Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="animate-pulse">
                  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="p-6 pb-4">
                      <div className="flex items-center space-x-4">
                        <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
                        <div className="flex-1 space-y-2">
                          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>
                      </div>
                    </div>
                    <div className="px-6 pb-4">
                      <div className="bg-gray-50 rounded-xl p-4">
                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                      </div>
                    </div>
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                      <div className="flex items-center justify-center space-x-3">
                        {Array.from({ length: 4 }).map((_, i) => (
                          <div key={i} className="w-10 h-10 bg-gray-200 rounded-full"></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : agentList.length === 0 ? (
              // Empty state
              <div className="col-span-full flex flex-col items-center justify-center py-16">
                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">No agents found</h3>
                <p className="text-gray-500 text-center max-w-sm">
                  Get started by adding your first agent to the system.
                </p>
                <button
                  onClick={() => setShowAddNewAgent(true)}
                  className="mt-4 btn btn-primary-2 gap-1 items-center shadow-md"
                >
                  <span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.98389 1.24805C6.24188 1.24805 6.45103 1.45719 6.45103 1.71519V5.45229H10.1881C10.4461 5.45229 10.6553 5.66144 10.6553 5.91943C10.6553 6.17743 10.4461 6.38657 10.1881 6.38657H6.45103V10.1237C6.45103 10.3817 6.24188 10.5908 5.98389 10.5908C5.72589 10.5908 5.51675 10.3817 5.51675 10.1237V6.38657H1.77964C1.52165 6.38657 1.3125 6.17743 1.3125 5.91943C1.3125 5.66144 1.52165 5.45229 1.77964 5.45229H5.51675V1.71519C5.51675 1.45719 5.72589 1.24805 5.98389 1.24805Z" fill="black" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span>Add Agent</span>
                </button>
              </div>
            ) : (
              agentList.map((agent, index) => {
                  const label = agent.agent_role?.name
                  return (
                      <div key={agent.id || index} className="intro-y">
                        {/* Modern Agent Card */}
                        <div className="group relative bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden transform hover:-translate-y-1">
                          
                          {/* Available Balance Badge */}
                          <div className="absolute top-4 left-4 z-10">
                            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium">
                              Available: {agent.agency?.country?.currency_symbol}{agent.balance_available}
                            </span>
                          </div>

                          {/* Agent Role Badge */}
                          <div className="absolute top-4 right-4 z-10">
                            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                              label === "Agent" 
                                ? 'bg-green-100 text-green-700' 
                                : 'bg-orange-100 text-orange-700'
                            }`}>
                              {label}
                            </span>
                          </div>

                          {/* Card Header */}
                          <div className="p-6 pb-4">
                            <div className="flex items-center space-x-4">
                              <div className="relative">
                                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-lg">
                                  <img
                                    alt={`${agent.firstname} ${agent.lastname}`}
                                    className="w-14 h-14 rounded-full object-cover border-2 border-white"
                                    src="https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png"
                                  />
                                </div>
                                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                  </svg>
                                </div>
                              </div>
                              
                              <div className="flex-1 min-w-0">
                                <Link 
                                  to={`/agent/${agent.id}`}
                                  className="text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors duration-200 truncate block"
                                >
                                  {`${agent.firstname} ${agent.lastname}`}
                                </Link>
                                <p className="text-sm text-gray-500 truncate">
                                  {agent.agency?.name}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* Card Body */}
                          <div className="px-6 pb-4">
                            <div className="bg-gray-50 rounded-xl p-4">
                              <div className="flex justify-between items-center">
                                <span className="text-sm font-medium text-gray-600">Actual Balance</span>
                                <span className="text-lg font-bold text-gray-900">
                                  {agent.agency?.country?.currency_symbol}{agent.actual_balance}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Card Footer - Actions */}
                          <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                            <div className="flex items-center justify-center space-x-3">
                              <button
                                data-tip="Top Up Agent E-Value"
                                onClick={() => setTopUpEValue(agent)}
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-green-100 hover:bg-green-200 text-green-600 transition-colors duration-200"
                              >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clipRule="evenodd" />
                                </svg>
                              </button>

                              {/* Reduce Agent Debt */}
                              <button
                                data-tip="Reduce Agent Debt"
                                onClick={() => setReduceProfile(agent)}
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 hover:bg-red-200 text-red-600 transition-colors duration-200"
                              >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4m8-8a8 8 0 100 16 8 8 0 000-16z" />
                                </svg>
                              </button>

                              <Link
                                to={`/statement/agent/${agent.id}`}
                                data-tip="View Statement"
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 transition-colors duration-200"
                              >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clipRule="evenodd" />
                                </svg>
                              </Link>

                              <Link
                                to={`/commissions/agent/${agent.id}`}
                                data-tip="View Commissions"
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100 hover:bg-yellow-200 text-yellow-600 transition-colors duration-200"
                              >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                              </Link>

                              <Link
                                to={`/agent/${agent.id}`}
                                data-tip="View Profile"
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-100 hover:bg-purple-200 text-purple-600 transition-colors duration-200"
                              >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                              </Link>
                            </div>
                          </div>
                        </div>
                        <ReactTooltip backgroundColor="#f1f5f8" textColor="black"/>
                      </div>
                  )
                }
              )
            )}
          </div>
          </div>
          {topUpEValue && <Modal onClick={topUp}
                                 disableButton={!topUpEValueAmount || isNaN(topUpEValueAmount) || topUpEValueAmount <= 0}
                                 modalTitle="Top up agent e-value" buttonTitle="Top up" buttonColor={"bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800"}
                                 size="small" body={
            <div className="space-y-6">
              {/* Agent Info Card */}
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">Agent E-Value Top Up</h4>
                    <p className="text-sm text-gray-600">Add funds to the agent's e-value balance</p>
                  </div>
                </div>
              </div>

              {/* Amount Input */}
              <div className="space-y-3">
                <label className="block text-sm font-medium text-gray-700">
                  Top Up Amount <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <input 
                    type="number" 
                    value={topUpEValueAmount}
                    onChange={(e) => setTopUpEValueAmount(e.target.value)}
                    name="topup"
                    className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                      (!topUpEValueAmount || isNaN(topUpEValueAmount) || topUpEValueAmount <= 0) 
                        ? 'border-red-300 bg-red-50' 
                        : 'border-gray-300'
                    }`}
                    placeholder="Enter amount to add"
                    min="0"
                    step="0.01"
                  />
                </div>
                {(!topUpEValueAmount || isNaN(topUpEValueAmount) || topUpEValueAmount <= 0) && (
                  <p className="text-red-500 text-sm flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    Enter a valid number greater than 0
                  </p>
                )}
              </div>

              {/* Summary Card */}
              {topUpEValueAmount && !isNaN(topUpEValueAmount) && topUpEValueAmount > 0 && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-3">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h4 className="text-sm font-medium text-blue-900">Transaction Summary</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-blue-700">Amount to add:</span>
                      <span className="font-semibold text-blue-900">${parseFloat(topUpEValueAmount).toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-blue-700">Current balance:</span>
                      <span className="font-semibold text-blue-900">${parseFloat(topUpEValue?.actual_balance || 0).toFixed(2)}</span>
                    </div>
                    <div className="border-t border-blue-200 pt-2">
                      <div className="flex justify-between">
                        <span className="font-medium text-blue-900">New e-value balance:</span>
                        <span className="font-bold text-blue-900">${(parseFloat(topUpEValue?.actual_balance || 0) + parseFloat(topUpEValueAmount)).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Info Note */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                <div className="flex items-start space-x-2">
                  <svg className="w-4 h-4 text-gray-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-xs text-gray-600">
                    The e-value will be added to the agent's account immediately and can be used for transactions.
                  </p>
                </div>
              </div>
            </div>
          } onClose={() => {
            setTopUpEValue(undefined);
            setTopUpEValueAmount(0)
          }}/>}

          {reduceProfile && <Modal onClick={reduceDebt}
                                   disableButton={!reduceProfileAmount || isNaN(reduceProfileAmount) || reduceProfileAmount <= 0}
                                   modalTitle="Reduce agent debt profile" buttonTitle="Reduce debt"
                                   buttonColor={"bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"} size="small" body={
            <div className="space-y-6">
              {/* Agent Debt Info Card */}
              <div className="bg-gradient-to-r from-red-50 to-rose-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">Reduce Agent Debt</h4>
                    <p className="text-sm text-gray-600">Decrease the agent's outstanding debt balance</p>
                  </div>
                </div>
              </div>

              {/* Amount Input */}
              <div className="space-y-3">
                <label className="block text-sm font-medium text-gray-700">
                  Reduction Amount <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4m16 0l-4 4m4-4l-4-4" />
                    </svg>
                  </div>
                  <input 
                    type="number" 
                    value={reduceProfileAmount}
                    onChange={(e) => setReduceProfileAmount(e.target.value)}
                    name="reduce"
                    className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 ${
                      (!reduceProfileAmount || isNaN(reduceProfileAmount) || reduceProfileAmount <= 0) 
                        ? 'border-red-300 bg-red-50' 
                        : 'border-gray-300'
                    }`}
                    placeholder="Enter amount to reduce"
                    min="0"
                    step="0.01"
                  />
                </div>
                {(!reduceProfileAmount || isNaN(reduceProfileAmount) || reduceProfileAmount <= 0) && (
                  <p className="text-red-500 text-sm flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    Enter a valid number greater than 0
                  </p>
                )}
              </div>

              {/* Summary Card */}
              {reduceProfileAmount && !isNaN(reduceProfileAmount) && reduceProfileAmount > 0 && (
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-3">
                    <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h4 className="text-sm font-medium text-orange-900">Debt Reduction Summary</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-orange-700">Amount to reduce:</span>
                      <span className="font-semibold text-orange-900">${parseFloat(reduceProfileAmount).toFixed(2)}</span>
                    </div>
                    <div className="border-t border-orange-200 pt-2">
                      <div className="flex justify-between">
                        <span className="font-medium text-orange-900">Debt reduction:</span>
                        <span className="font-bold text-orange-900">-${parseFloat(reduceProfileAmount).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Warning Note */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <div className="flex items-start space-x-2">
                  <svg className="w-4 h-4 text-yellow-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                  <p className="text-xs text-yellow-700">
                    <strong>Important:</strong> This action will permanently reduce the agent's debt balance. Make sure the amount is correct before proceeding.
                  </p>
                </div>
              </div>
            </div>
          } onClose={() => {
            setReduceProfile(undefined);
            setReduceProfileAmount(0)
          }}/>}

          <div className="flex flex-col mb-[10vh] gap-4 justify-between md:items-center md:flex-row mt-8">
            <div className="page text-[#999999] text-xs">
              Showing {from} to {pageTo} of {totalEntries} entries
            </div>

            <div className="mt-3  flex justify-end float-right">
              <PaginationComponent
                  current={currentPage}
                  defaultCurrent={currentPage}
                  showSizeChanger={false}
                  onChange={pageChange}
                  total={totalEntries}
              />
            </div>
          </div>
          {showAddNewAgent && (
              <AddNewAgent
                  show={showAddNewAgent}
                  setShow={setShowAddNewAgent}
                  refetchData={fetchAgents}
              />
          )}
        </>

    )
}
export default Agents;
